import { ReactNode } from "react";
import clsx from "clsx";
import { Controller, RegisterOptions } from "react-hook-form";

import Checkbox from "@/components/atoms/Checkbox";
import InputDescription from "@/components/atoms/input/InputDescription";
import InputError from "@/components/atoms/input/InputError";
import InputLabel from "@/components/atoms/input/InputLabel";

type FormInputProps = {
  name: string;
  label: ReactNode | string;
  description?: string;
  rules?: RegisterOptions;
  disabled?: boolean;
  sizing?: "sm" | "md";
  align?: "left" | "right";
  indeterminate?: boolean;
};

const FormCheckbox = ({
  name,
  label,
  description,
  align = "left",
  sizing,
  rules,
  disabled = false,
  indeterminate = false,
}: FormInputProps) => {
  return (
    <Controller
      name={name}
      rules={rules}
      render={({ field: { onChange, value, name }, fieldState: { error } }) => (
        <div className={clsx("flex disabled-within:opacity-40", align === "left" ? "flex-row-reverse gap-2" : "gap-4")}>
          <div className={"grid flex-1 gap-1.5"}>
            <div className={"grid gap-0.5"}>
              <InputLabel label={label} htmlFor={name} className={"!font-normal"} />
              {description && <InputDescription text={description} />}
            </div>
            <InputError error={error?.message} />
          </div>
          <Checkbox
            className={"mt-0.5"}
            id={name}
            checked={value}
            onChange={onChange}
            sizing={sizing}
            disabled={disabled}
            indeterminate={indeterminate}
          />
        </div>
      )}
    />
  );
};

export default FormCheckbox;
